import React from 'react';
import TransferMethodDF from '../components/SimulatorsComponents/DefualtSimulators/TransferMethodDF';
import { getSubCategoryId } from '../utils/DictionaryManagementUtils';

const Sim_B03_SendMoneyTransferMethod = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const { recipient } = globJSON.configurations.services[subCategoryId];

  return (
    <TransferMethodDF
      globJSON={globJSON}
      simPlatform={simPlatform}
      recipient={recipient}
      slideshowRefs={slideshowRefs}
    />
  );
};

export default Sim_B03_SendMoneyTransferMethod;
